import { useEffect, useState } from 'react';
import { getSiteStatus } from '../api';
import { getMaintenanceMessage, isSiteAvailable } from '../utils/siteStatus';
import Loader from './ui/Loader';
import MaintenancePage from './MaintenancePage';
import './SiteStatusGate.scss';

export default function SiteStatusGate({ children }) {
    const [state, setState] = useState('loading');
    const [message, setMessage] = useState(null);
    const [reason, setReason] = useState('admin');

    useEffect(() => {
        const controller = new AbortController();

        const checkStatus = async () => {
            try {
                const data = await getSiteStatus(controller.signal);

                if (isSiteAvailable(data)) {
                    setState('available');
                    setMessage(null);
                    return;
                }

                setReason('admin');
                setMessage(getMaintenanceMessage(data));
                setState('maintenance');
            } catch (error) {
                if (error?.code === 'ERR_CANCELED') {
                    return;
                }

                setReason('unreachable');
                setMessage(null);
                setState('maintenance');
            }
        };

        checkStatus();

        return () => {
            controller.abort();
        };
    }, []);

    if (state === 'loading') {
        return (
            <div className="site-status-gate">
                <Loader text="Проверяем доступность..." />
            </div>
        );
    }

    if (state === 'maintenance') {
        return <MaintenancePage message={message} reason={reason} />;
    }

    return <div className="site-status-gate site-status-gate--ready">{children}</div>;
}
